module.exports = __webpack_public_path__ + "static/media/threestepicon3.d8c4bc14.png";